import { Image, Page, StyleSheet, View } from "@react-pdf/renderer";
import React from "react";
import _ from "lodash";
import { getPresignedUrl } from "../../upload/utils";
import {
    calculateImageDimensions,
    convertPdfToImages,
    getFooter,
} from "../../../utils/helperUtils";

const styles = StyleSheet.create({
    page: {
        padding: "40px 50px",
        backgroundColor: "#ffffff",
        position: "relative",
    },
    mainContainer: {
        flex: 1,
        paddingBottom: 50,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    imageContainer: {
        border: "1px solid #e0e0e0",
        borderRadius: 4,
        backgroundColor: "#f8f9fa",
        padding: 10,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
});

interface ConvertedImage {
    url: string;
    width: number;
    height: number;
}

const getEnabledAttachments = (data: any) => {
    const attachments = _.get(
        data,
        "appealApproachCalculationData.exportAppealsPackage.attachments",
        []
    );

    return attachments
        .filter((attachment: { enable: boolean }) => attachment.enable === true)
        .map(attachment => ({ s3Key: attachment.canopyS3Key }));
};

const ImagePage: React.FC<{
    image: ConvertedImage;
    confidentialInfo: string;
}> = ({ image, confidentialInfo }) => {
    const dimensions = calculateImageDimensions(image.width, image.height);

    return (
        <Page size="A4" style={styles.page}>
            <View style={styles.mainContainer}>
                <View style={styles.imageContainer}>
                    <Image
                        src={image.url}
                        style={{
                            width: dimensions.width,
                            height: dimensions.height,
                        }}
                    />
                </View>
            </View>

            {getFooter(confidentialInfo)}
        </Page>
    );
};

export const AppealAttachmentsPage = async (data: any, confidentialInfo: string) => {
    try {
        const attachments = getEnabledAttachments(data);
        const attachmentUrls = await Promise.all(
            attachments.map(attachment => getPresignedUrl(attachment.s3Key))
        );

        const allPages = await Promise.all(
            attachmentUrls.map(async url => {
                const convertedImages = await convertPdfToImages(url);

                return convertedImages.map((image, index) => (
                    <ImagePage
                        key={`page-${url}-${index}`}
                        image={image}
                        confidentialInfo={confidentialInfo}
                    />
                ));
            })
        );

        return allPages.flat();
    } catch (error) {
        console.error("Error generating appeal attachments:", error);

        return [];
    }
};
